const FormRender = {
  props: [
    {
      name: 'def',
      default: '',
      type: 'FormDef',
      desc: '表单定义'
    },
    {
      name: 'form',
      default: '{}',
      type: 'Record<string | number, any>',
      desc: '表单数据'
    }
  ],
  slots: [
    {
      name: '*',
      value: '{options, proxy}',
      desc: '自定义控件'
    }
  ],
  methods: [
    {
      name: 'validate',
      value: 'validate () => Promise<boolean>',
      desc: '验证表单'
    },
    {
      name: 'reset',
      value: 'reset () => void',
      desc: '重置表单'
    },
    {
      name: 'submit',
      value: 'submit () => Promise<Record<string | number, any>>',
      desc: '提交表单'
    }
  ]
}

export default [
  {
    name: 'FormRender API',
    content: FormRender
  }
]
